"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BicyclesBanner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var services_1 = require("@falcon/services");
var BicyclesBanner = /** @class */ (function (_super) {
    __extends(BicyclesBanner, _super);
    function BicyclesBanner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BicyclesBanner.prototype.render = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "banner carousel-banner banner-content", children: [(0, jsx_runtime_1.jsx)("img", { className: "banner-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/bicycle-icon.svg"), alt: "Bicycles away from home" }), (0, jsx_runtime_1.jsxs)("div", { className: "banner-text", children: [(0, jsx_runtime_1.jsx)("div", { className: "banner-title mb-3", children: "Bicycles away from home" }), "Protect your bicycles against accidental loss, damage and theft from home.", (0, jsx_runtime_1.jsx)("br", {}), "You need to list any bicycles and their accessories worth over \u00A3350.", (0, jsx_runtime_1.jsxs)("p", { className: "mt-3", children: [(0, jsx_runtime_1.jsx)("img", { className: "carousel-banner-arrow", src: "/".concat(services_1.resourcesHelper.THEME, "/img/arrow-right.svg"), alt: "Arrow icon" }), (0, jsx_runtime_1.jsx)("button", { className: "btn-text cursor-pointer", onClick: function () { return _this.props.editCoverLevelNavigate(); }, children: "Add bicycle" })] })] })] }));
    };
    return BicyclesBanner;
}(React.Component));
exports.BicyclesBanner = BicyclesBanner;
//# sourceMappingURL=BicyclesBanner.js.map